/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type AuthenticationInfo,
    AuthenticationInfoFromJSON,
    AuthenticationInfoToJSON,
} from '../models/AuthenticationInfo';
import {
    type ErrorResponse,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
} from '../models/ErrorResponse';
import {
    type LoginToken,
    LoginTokenFromJSON,
    LoginTokenToJSON,
} from '../models/LoginToken';

export interface LoginTokensAuthRouteRequest {
    redirect: string;
}

export interface LoginTokensCreateLoginTokenRequest {
    authenticationInfo: AuthenticationInfo;
}

export interface LoginTokensDeleteLoginTokenRequest {
    loginTokenId: string;
}

export interface LoginTokensFrontChannelLogoutGetRequest {
    sid: string;
}

export interface LoginTokensReadLoginTokenRequest {
    loginTokenId: string;
}

export interface LoginTokensRedirectRouteRequest {
    code?: string | null;
    state?: string | null;
    error?: string | null;
    errorDescription?: string | null;
}

/**
 * LoginTokensApi - interface
 * 
 * @export
 * @interface LoginTokensApiInterface
 */
export interface LoginTokensApiInterface {
    /**
     * Creates request options for loginTokensAuthRoute without sending the request
     * @param {string} redirect 
     * @throws {RequiredError}
     * @memberof LoginTokensApiInterface
     */
    loginTokensAuthRouteRequestOpts(requestParameters: LoginTokensAuthRouteRequest): Promise<runtime.RequestOpts>;

    /**
     * Returns a URL that the frontend will redirect the user to. The URL contains the ID of the state holding the redirect URL. We store the state in our database so that we can make sure the state has been initiated by us. The identity provider will then redirect the user back to `/login_tokens/oidc/redirect-uri`.
     * @summary Get OIDC authentication URL
     * @param {string} redirect 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginTokensApiInterface
     */
    loginTokensAuthRouteRaw(requestParameters: LoginTokensAuthRouteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>>;

    /**
     * Returns a URL that the frontend will redirect the user to. The URL contains the ID of the state holding the redirect URL. We store the state in our database so that we can make sure the state has been initiated by us. The identity provider will then redirect the user back to `/login_tokens/oidc/redirect-uri`.
     * Get OIDC authentication URL
     */
    loginTokensAuthRoute(requestParameters: LoginTokensAuthRouteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string>;

    /**
     * Creates request options for loginTokensCreateLoginToken without sending the request
     * @param {AuthenticationInfo} authenticationInfo 
     * @throws {RequiredError}
     * @memberof LoginTokensApiInterface
     */
    loginTokensCreateLoginTokenRequestOpts(requestParameters: LoginTokensCreateLoginTokenRequest): Promise<runtime.RequestOpts>;

    /**
     * Create a login token by email and password or an NFC token. This is typically the route that one uses in order to log in.
     * @summary Create a login token
     * @param {AuthenticationInfo} authenticationInfo 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginTokensApiInterface
     */
    loginTokensCreateLoginTokenRaw(requestParameters: LoginTokensCreateLoginTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LoginToken>>;

    /**
     * Create a login token by email and password or an NFC token. This is typically the route that one uses in order to log in.
     * Create a login token
     */
    loginTokensCreateLoginToken(requestParameters: LoginTokensCreateLoginTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LoginToken>;

    /**
     * Creates request options for loginTokensDeleteLoginToken without sending the request
     * @param {string} loginTokenId 
     * @throws {RequiredError}
     * @memberof LoginTokensApiInterface
     */
    loginTokensDeleteLoginTokenRequestOpts(requestParameters: LoginTokensDeleteLoginTokenRequest): Promise<runtime.RequestOpts>;

    /**
     * Delete the login token with the given ID.
     * @summary Delete a login token
     * @param {string} loginTokenId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginTokensApiInterface
     */
    loginTokensDeleteLoginTokenRaw(requestParameters: LoginTokensDeleteLoginTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Delete the login token with the given ID.
     * Delete a login token
     */
    loginTokensDeleteLoginToken(requestParameters: LoginTokensDeleteLoginTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Creates request options for loginTokensFrontChannelLogoutGet without sending the request
     * @param {string} sid 
     * @throws {RequiredError}
     * @memberof LoginTokensApiInterface
     */
    loginTokensFrontChannelLogoutGetRequestOpts(requestParameters: LoginTokensFrontChannelLogoutGetRequest): Promise<runtime.RequestOpts>;

    /**
     * The OpenID provider will render this route in an iframe when the user logs out.
     * @summary OpenID Connect front-channel logout callback route
     * @param {string} sid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginTokensApiInterface
     */
    loginTokensFrontChannelLogoutGetRaw(requestParameters: LoginTokensFrontChannelLogoutGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * The OpenID provider will render this route in an iframe when the user logs out.
     * OpenID Connect front-channel logout callback route
     */
    loginTokensFrontChannelLogoutGet(requestParameters: LoginTokensFrontChannelLogoutGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Creates request options for loginTokensListLoginTokens without sending the request
     * @throws {RequiredError}
     * @memberof LoginTokensApiInterface
     */
    loginTokensListLoginTokensRequestOpts(): Promise<runtime.RequestOpts>;

    /**
     * Lists all the login tokens for the current user.
     * @summary List login tokens for the current user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginTokensApiInterface
     */
    loginTokensListLoginTokensRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<LoginToken>>>;

    /**
     * Lists all the login tokens for the current user.
     * List login tokens for the current user.
     */
    loginTokensListLoginTokens(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<LoginToken>>;

    /**
     * Creates request options for loginTokensLogoutGet without sending the request
     * @throws {RequiredError}
     * @memberof LoginTokensApiInterface
     */
    loginTokensLogoutGetRequestOpts(): Promise<runtime.RequestOpts>;

    /**
     * Returns the identity provider\'s end session URL. After this completes it will render the configured front-channel logout URL in an invisible iframe to end the session.
     * @summary Get identity provider logout URL
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginTokensApiInterface
     */
    loginTokensLogoutGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>>;

    /**
     * Returns the identity provider\'s end session URL. After this completes it will render the configured front-channel logout URL in an invisible iframe to end the session.
     * Get identity provider logout URL
     */
    loginTokensLogoutGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string>;

    /**
     * Creates request options for loginTokensReadLoginToken without sending the request
     * @param {string} loginTokenId 
     * @throws {RequiredError}
     * @memberof LoginTokensApiInterface
     */
    loginTokensReadLoginTokenRequestOpts(requestParameters: LoginTokensReadLoginTokenRequest): Promise<runtime.RequestOpts>;

    /**
     * Returns a single login token specified by the given ID.
     * @summary Get a single login token
     * @param {string} loginTokenId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginTokensApiInterface
     */
    loginTokensReadLoginTokenRaw(requestParameters: LoginTokensReadLoginTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LoginToken>>;

    /**
     * Returns a single login token specified by the given ID.
     * Get a single login token
     */
    loginTokensReadLoginToken(requestParameters: LoginTokensReadLoginTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LoginToken>;

    /**
     * Creates request options for loginTokensRedirectRoute without sending the request
     * @param {string} [code] 
     * @param {string} [state] 
     * @param {string} [error] 
     * @param {string} [errorDescription] 
     * @throws {RequiredError}
     * @memberof LoginTokensApiInterface
     */
    loginTokensRedirectRouteRequestOpts(requestParameters: LoginTokensRedirectRouteRequest): Promise<runtime.RequestOpts>;

    /**
     * Route the identity provider redirects to. If authentication succeeded the `code` query parameter will be set. Otherwise the `error` and `error_description` parameters will be set.
     * @summary OpenID Connect callback redirect route
     * @param {string} [code] 
     * @param {string} [state] 
     * @param {string} [error] 
     * @param {string} [errorDescription] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginTokensApiInterface
     */
    loginTokensRedirectRouteRaw(requestParameters: LoginTokensRedirectRouteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Route the identity provider redirects to. If authentication succeeded the `code` query parameter will be set. Otherwise the `error` and `error_description` parameters will be set.
     * OpenID Connect callback redirect route
     */
    loginTokensRedirectRoute(requestParameters: LoginTokensRedirectRouteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Creates request options for loginTokensRefresh without sending the request
     * @throws {RequiredError}
     * @memberof LoginTokensApiInterface
     */
    loginTokensRefreshRequestOpts(): Promise<runtime.RequestOpts>;

    /**
     * Refreshes provided login token backed by OICD session. If the session is refreshed successfully the server will return new login token and cookie. If the session could not be refreshed the current login token will be terminated resulting in user log out.
     * @summary OpenID Connect refresh session
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginTokensApiInterface
     */
    loginTokensRefreshRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LoginToken>>;

    /**
     * Refreshes provided login token backed by OICD session. If the session is refreshed successfully the server will return new login token and cookie. If the session could not be refreshed the current login token will be terminated resulting in user log out.
     * OpenID Connect refresh session
     */
    loginTokensRefresh(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LoginToken>;

}

/**
 * 
 */
export class LoginTokensApi extends runtime.BaseAPI implements LoginTokensApiInterface {

    /**
     * Creates request options for loginTokensAuthRoute without sending the request
     */
    async loginTokensAuthRouteRequestOpts(requestParameters: LoginTokensAuthRouteRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['redirect'] == null) {
            throw new runtime.RequiredError(
                'redirect',
                'Required parameter "redirect" was null or undefined when calling loginTokensAuthRoute().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['redirect'] != null) {
            queryParameters['redirect'] = requestParameters['redirect'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/login_tokens/oidc/auth-url`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns a URL that the frontend will redirect the user to. The URL contains the ID of the state holding the redirect URL. We store the state in our database so that we can make sure the state has been initiated by us. The identity provider will then redirect the user back to `/login_tokens/oidc/redirect-uri`.
     * Get OIDC authentication URL
     */
    async loginTokensAuthRouteRaw(requestParameters: LoginTokensAuthRouteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const requestOptions = await this.loginTokensAuthRouteRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Returns a URL that the frontend will redirect the user to. The URL contains the ID of the state holding the redirect URL. We store the state in our database so that we can make sure the state has been initiated by us. The identity provider will then redirect the user back to `/login_tokens/oidc/redirect-uri`.
     * Get OIDC authentication URL
     */
    async loginTokensAuthRoute(requestParameters: LoginTokensAuthRouteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.loginTokensAuthRouteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for loginTokensCreateLoginToken without sending the request
     */
    async loginTokensCreateLoginTokenRequestOpts(requestParameters: LoginTokensCreateLoginTokenRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['authenticationInfo'] == null) {
            throw new runtime.RequiredError(
                'authenticationInfo',
                'Required parameter "authenticationInfo" was null or undefined when calling loginTokensCreateLoginToken().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/login_tokens/`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AuthenticationInfoToJSON(requestParameters['authenticationInfo']),
        };
    }

    /**
     * Create a login token by email and password or an NFC token. This is typically the route that one uses in order to log in.
     * Create a login token
     */
    async loginTokensCreateLoginTokenRaw(requestParameters: LoginTokensCreateLoginTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LoginToken>> {
        const requestOptions = await this.loginTokensCreateLoginTokenRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LoginTokenFromJSON(jsonValue));
    }

    /**
     * Create a login token by email and password or an NFC token. This is typically the route that one uses in order to log in.
     * Create a login token
     */
    async loginTokensCreateLoginToken(requestParameters: LoginTokensCreateLoginTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LoginToken> {
        const response = await this.loginTokensCreateLoginTokenRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for loginTokensDeleteLoginToken without sending the request
     */
    async loginTokensDeleteLoginTokenRequestOpts(requestParameters: LoginTokensDeleteLoginTokenRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['loginTokenId'] == null) {
            throw new runtime.RequiredError(
                'loginTokenId',
                'Required parameter "loginTokenId" was null or undefined when calling loginTokensDeleteLoginToken().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/login_tokens/{login_token_id}`;
        urlPath = urlPath.replace('{login_token_id}', encodeURIComponent(String(requestParameters['loginTokenId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Delete the login token with the given ID.
     * Delete a login token
     */
    async loginTokensDeleteLoginTokenRaw(requestParameters: LoginTokensDeleteLoginTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.loginTokensDeleteLoginTokenRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete the login token with the given ID.
     * Delete a login token
     */
    async loginTokensDeleteLoginToken(requestParameters: LoginTokensDeleteLoginTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.loginTokensDeleteLoginTokenRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for loginTokensFrontChannelLogoutGet without sending the request
     */
    async loginTokensFrontChannelLogoutGetRequestOpts(requestParameters: LoginTokensFrontChannelLogoutGetRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['sid'] == null) {
            throw new runtime.RequiredError(
                'sid',
                'Required parameter "sid" was null or undefined when calling loginTokensFrontChannelLogoutGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sid'] != null) {
            queryParameters['sid'] = requestParameters['sid'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/login_tokens/oidc/front-channel-logout`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * The OpenID provider will render this route in an iframe when the user logs out.
     * OpenID Connect front-channel logout callback route
     */
    async loginTokensFrontChannelLogoutGetRaw(requestParameters: LoginTokensFrontChannelLogoutGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.loginTokensFrontChannelLogoutGetRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * The OpenID provider will render this route in an iframe when the user logs out.
     * OpenID Connect front-channel logout callback route
     */
    async loginTokensFrontChannelLogoutGet(requestParameters: LoginTokensFrontChannelLogoutGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.loginTokensFrontChannelLogoutGetRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for loginTokensListLoginTokens without sending the request
     */
    async loginTokensListLoginTokensRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/login_tokens/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Lists all the login tokens for the current user.
     * List login tokens for the current user.
     */
    async loginTokensListLoginTokensRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<LoginToken>>> {
        const requestOptions = await this.loginTokensListLoginTokensRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(LoginTokenFromJSON));
    }

    /**
     * Lists all the login tokens for the current user.
     * List login tokens for the current user.
     */
    async loginTokensListLoginTokens(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<LoginToken>> {
        const response = await this.loginTokensListLoginTokensRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for loginTokensLogoutGet without sending the request
     */
    async loginTokensLogoutGetRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/login_tokens/oidc/logout-url`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns the identity provider\'s end session URL. After this completes it will render the configured front-channel logout URL in an invisible iframe to end the session.
     * Get identity provider logout URL
     */
    async loginTokensLogoutGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const requestOptions = await this.loginTokensLogoutGetRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Returns the identity provider\'s end session URL. After this completes it will render the configured front-channel logout URL in an invisible iframe to end the session.
     * Get identity provider logout URL
     */
    async loginTokensLogoutGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.loginTokensLogoutGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for loginTokensReadLoginToken without sending the request
     */
    async loginTokensReadLoginTokenRequestOpts(requestParameters: LoginTokensReadLoginTokenRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['loginTokenId'] == null) {
            throw new runtime.RequiredError(
                'loginTokenId',
                'Required parameter "loginTokenId" was null or undefined when calling loginTokensReadLoginToken().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/login_tokens/{login_token_id}`;
        urlPath = urlPath.replace('{login_token_id}', encodeURIComponent(String(requestParameters['loginTokenId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns a single login token specified by the given ID.
     * Get a single login token
     */
    async loginTokensReadLoginTokenRaw(requestParameters: LoginTokensReadLoginTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LoginToken>> {
        const requestOptions = await this.loginTokensReadLoginTokenRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LoginTokenFromJSON(jsonValue));
    }

    /**
     * Returns a single login token specified by the given ID.
     * Get a single login token
     */
    async loginTokensReadLoginToken(requestParameters: LoginTokensReadLoginTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LoginToken> {
        const response = await this.loginTokensReadLoginTokenRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for loginTokensRedirectRoute without sending the request
     */
    async loginTokensRedirectRouteRequestOpts(requestParameters: LoginTokensRedirectRouteRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['code'] != null) {
            queryParameters['code'] = requestParameters['code'];
        }

        if (requestParameters['state'] != null) {
            queryParameters['state'] = requestParameters['state'];
        }

        if (requestParameters['error'] != null) {
            queryParameters['error'] = requestParameters['error'];
        }

        if (requestParameters['errorDescription'] != null) {
            queryParameters['error_description'] = requestParameters['errorDescription'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/login_tokens/oidc/redirect-uri`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Route the identity provider redirects to. If authentication succeeded the `code` query parameter will be set. Otherwise the `error` and `error_description` parameters will be set.
     * OpenID Connect callback redirect route
     */
    async loginTokensRedirectRouteRaw(requestParameters: LoginTokensRedirectRouteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.loginTokensRedirectRouteRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Route the identity provider redirects to. If authentication succeeded the `code` query parameter will be set. Otherwise the `error` and `error_description` parameters will be set.
     * OpenID Connect callback redirect route
     */
    async loginTokensRedirectRoute(requestParameters: LoginTokensRedirectRouteRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.loginTokensRedirectRouteRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for loginTokensRefresh without sending the request
     */
    async loginTokensRefreshRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/login_tokens/oidc/refresh`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Refreshes provided login token backed by OICD session. If the session is refreshed successfully the server will return new login token and cookie. If the session could not be refreshed the current login token will be terminated resulting in user log out.
     * OpenID Connect refresh session
     */
    async loginTokensRefreshRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LoginToken>> {
        const requestOptions = await this.loginTokensRefreshRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LoginTokenFromJSON(jsonValue));
    }

    /**
     * Refreshes provided login token backed by OICD session. If the session is refreshed successfully the server will return new login token and cookie. If the session could not be refreshed the current login token will be terminated resulting in user log out.
     * OpenID Connect refresh session
     */
    async loginTokensRefresh(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LoginToken> {
        const response = await this.loginTokensRefreshRaw(initOverrides);
        return await response.value();
    }

}
